import React from "react";
import CircularProgress from "@mui/material/CircularProgress";

/**
 * [PRD-2043] Inline loader for the billing dashboard's in-card tabs and modals.
 * Unlike the global PageLoader (a full-screen `position: fixed` overlay that
 * flashes the whole viewport), this stays inside the content area, so switching
 * tabs / reopening the modal doesn't make the screen flicker.
 */
export default function InlineLoader() {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: 160,
        width: "100%",
      }}
    >
      <CircularProgress />
    </div>
  );
}
